
// ROUTES
require('modules/auth/routes/auth');

// CONTROLLERS
require('modules/auth/controllers/auth');
require('modules/auth/controllers/error');
require('modules/auth/controllers/login');
require('modules/auth/controllers/logout');
require('modules/auth/controllers/forgotten-password');
require('modules/auth/controllers/logout-success');
require('modules/auth/controllers/nam');


// SERVICES
require('modules/auth/services/auth');
require('modules/auth/services/login');
require('modules/auth/services/logout');
require('modules/auth/services/forgotten-password');
require('modules/auth/services/session');


angular.module('unica_auth', [

	// ROUTES
	'unica_auth.auth_routes',

	// CONTROLLERS
	'unica_auth.auth_controllers',

	// SERVICES
	'unica_auth.auth_services'

]);